import { render, staticRenderFns } from "./phonelist.vue?vue&type=template&id=3c5afcd6&scoped=true"
import script from "./phonelist.vue?vue&type=script&lang=js"
export * from "./phonelist.vue?vue&type=script&lang=js"
import style0 from "./phonelist.vue?vue&type=style&index=0&id=3c5afcd6&prod&lang=less&scoped=true"
import style1 from "./phonelist.vue?vue&type=style&index=1&id=3c5afcd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5afcd6",
  null
  
)

export default component.exports